import { useTranslation } from 'react-i18next';

interface SubscribeTitleProps {
  textColor: string;
}

export const SubscribeTitle = ({ textColor }: SubscribeTitleProps) => {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col gap-[6px] mb-[14px]'>
      <p className='font-body text-sm font-semibold' style={{ color: textColor }}>
        {t('subscribeWidget.subscribeSubTitle')}
      </p>
      <h1 className='font-body text-[28px] font-normal' style={{ color: textColor }}>
        {t('subscribeWidget.subscribeTitle')}
      </h1>
    </div>
  );
};
